import React, { useEffect, useState } from "react"
import FetchingDataScreen from "../../../components/fetchingDataScreen";
import { useDispatch, useSelector } from "react-redux";
import { ActivityIndicator, Alert, StyleSheet, Text, View } from "react-native";
import { isIOS } from "../../../utils/Helper";
import { CHECK, CHEVRON_DOWN, CHEVRON_RIGHT, CROSS, RIGHT_CHECK } from '../../../assets';
import CustomPressable from "../../../components/customPressable/customPressable";
import { ImageComp } from "../../../components/Image/Image";
import { useCssStyle } from "../../../customHook/getCssStyle";
import { useTranslation } from "react-i18next";
import { useNavigation } from "@react-navigation/native";
import HeaderWithBack from "../../../components/Header/headerWithBack";
import AccessingCamera from "../../../components/cameraAccessing/cameraAccess";
import { ValidateConfidence } from "./validateConfidence";
import { CHECKIN_DEMO_FLOW, DEMO_FLOW_ENABLED, MOBILE_CHECKIN_CATEGORY } from "../../../config/Constant";
import { ScrollView } from "react-native-gesture-handler";
import CustomDropDown from "../../../components/customDropdown/customDropdown";
import { getDocumentList } from "../../../Redux/Actions/checkInAction";
import { setRenderFlashMessage } from "../../../Redux/Actions/appConfigAction";
import Loader from "../../../components/Loader/loader";
import { sendAnalytics } from "../../../Redux/Actions/analyticsAction";


export const ID_FRONT = 'front';
export const ID_BACK = 'back';
export const SELFIE = 'selfie';
export const PROCEEDVERIFYID = 'verifyID';

const VerifyIdentity = (props) => {


    const {checkinSessionToken, lastName, disableLivelinessCheck, idVerificationMediaFiles, handleGoBack, handleCancel, handleNext, handleSkip } = props;

    const { t } = useTranslation();
    const getStyles = useCssStyle();
    const dispatch = useDispatch();
    const navigation = useNavigation();

    // const { guestAllowedDocumentListData } = useSelector(state => state.checkInSlice)
    const { data } = useSelector(state => state.documentListSlice);
    const guestAllowedDocumentListData = data?.guestAllowedDocumentListData


    const [initialLoading, setInitialLoading] = useState(false);

    const [highlightNextStep, setHighlightNextStep] = useState('');

    const [idVerificationLocalMediaFiles, setIdVerificationLocalMediaFiles] = useState({
        selectedIdType: {},
        idImageUri: "",
        idImageBackUri: "",
        idImagesInfo: {},
        selfieUri: "",
        selfieFiles: []
    })
    const [cameraConfigs, setCameraConfigs] = useState({
        accessCamera: false,
        pictureType: "",
        previewImageUri: "",
        cameraDirection: 'back',
    })

    const [initializedVerifyIdentity, setInitializedVerifyIdentity] = useState(false);

    const handleSetIdVerificationLocalMediaFiles = (updatedFiles) => {
        setIdVerificationLocalMediaFiles({ ...idVerificationLocalMediaFiles, ...updatedFiles })
    }

    const handleSelectedIDType = (selectedIDTypeInfo) => {
        if (!selectedIDTypeInfo) return;
    
        const selectedIDTypeInfoVar = guestAllowedDocumentListData.find(
            (item) => item.key === selectedIDTypeInfo.value
        );
    
        handleSetIdVerificationLocalMediaFiles({ selectedIdType: selectedIDTypeInfoVar || null });
    };

    const handleOpenCamera = (pictureType) => {

        if(!idVerificationLocalMediaFiles.selectedIdType?.key){
            dispatch(setRenderFlashMessage(true, {type: "danger", message: t('check_in.id_verification.select_id_warning')}));
            return;
        }

        const cameraDirection = pictureType === SELFIE ? 'front' : 'back';

        const previewImageUri =
            pictureType == ID_FRONT ? idVerificationLocalMediaFiles.idImageUri :
                pictureType == ID_BACK ? idVerificationLocalMediaFiles.idImageBackUri :
                    pictureType == SELFIE ? idVerificationLocalMediaFiles.selfieUri : "";

        setCameraConfigs({
            accessCamera: true,
            pictureType,
            previewImageUri,
            cameraDirection,
        });
    };

    const handleCloseCamera = () => {
        setCameraConfigs({
            accessCamera: false,
            pictureType: "",
            cameraDirection: 'back'
        });
    }



    const handleImageSave = (imageInfo) => {

        if (cameraConfigs.pictureType == ID_FRONT) {
            handleSetIdVerificationLocalMediaFiles({ idImageUri: imageInfo.imageUri })
            return;
        }

        if (cameraConfigs.pictureType == ID_BACK) {
            handleSetIdVerificationLocalMediaFiles({ idImageBackUri: imageInfo.imageUri })
            return;
        }

        if (cameraConfigs.pictureType == SELFIE) {
            handleSetIdVerificationLocalMediaFiles({ selfieUri: imageInfo.imageUri, selfieFiles: imageInfo.imageUriArr });
            return;
        }
    }

    useEffect(() => {

        if (!idVerificationLocalMediaFiles.idImageUri) {
            setHighlightNextStep(ID_FRONT);
            return;
        }

        if (idVerificationLocalMediaFiles.selectedIdType.bothSideImageRequired && !idVerificationLocalMediaFiles.idImageBackUri) {
            setHighlightNextStep(ID_BACK);
            return;
        }

        if (!idVerificationLocalMediaFiles.idImageUri) {
            setHighlightNextStep(ID_FRONT);
            return;
        }

        if (!disableLivelinessCheck && !idVerificationLocalMediaFiles.selfieUri) {
            setHighlightNextStep(SELFIE);
            return;
        }

        setHighlightNextStep(PROCEEDVERIFYID);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idVerificationLocalMediaFiles])

    useEffect(() => {
        setIdVerificationLocalMediaFiles({ ...idVerificationLocalMediaFiles, ...idVerificationMediaFiles });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idVerificationMediaFiles])





    const handleGuestAllowedDocumentListData = () => {
        if (!guestAllowedDocumentListData?.length) return;
    
        if (guestAllowedDocumentListData.length === 1) {
            handleSetIdVerificationLocalMediaFiles({ selectedIdType: guestAllowedDocumentListData[0] });
            return;
        }
    
        const defaultItem = guestAllowedDocumentListData.find(item => item.isDefault);
        if (defaultItem) {
            handleSetIdVerificationLocalMediaFiles({ selectedIdType: defaultItem });
        }
    };

    useEffect(() => {
        handleGuestAllowedDocumentListData();
        dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "ID VERIFICATION", { "element": "widget", "widgetSessionId": checkinSessionToken}));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const handleConfidenceCheckNext = (idImagesInfo) => {

        setInitializedVerifyIdentity(false);
        handleSetIdVerificationLocalMediaFiles({ idImagesInfo })

        // Access the updated media files (ensure you are working with the current state)
        const updatedMediaFiles = { ...idVerificationLocalMediaFiles, ...idImagesInfo };
        const { selfieFiles, ...otherMediaFiles } = updatedMediaFiles;

        handleNext(otherMediaFiles);
    }


    return cameraConfigs.accessCamera ?
        (
            <AccessingCamera
                cameraType={cameraConfigs.cameraDirection}
                previewImageUri={cameraConfigs.previewImageUri}
                detectLiveliness={cameraConfigs.pictureType == SELFIE}
                pictureType={cameraConfigs.pictureType}
                handleImageSave={handleImageSave}
                handleCloseCamera={handleCloseCamera}
            />
        ) : initialLoading ? (
            <FetchingDataScreen />
        ) : (
            <View style={getStyles(['widgetRootContainer', 'verifyIdentityRootContainer'])}>
                <HeaderWithBack hideBackButton={true} handleCustomBackPress={handleGoBack} handleCustomCancelClick={handleCancel} />

                <ScrollView contentContainerStyle={getStyles(['widgetmainContainer', 'verifyIdentityMainContainer'])} showsVerticalScrollIndicator={false}>

                    <View style={getStyles(['widgetmainContainerHeaderContainer', 'verifyIdentityHeaderContainer'])}>
                        <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'verifyIdentityHeaderTitleContainer'])}>
                            <Text style={getStyles(['widgetmainContainerHeaderTitle', 'verifyIdentityHeaderTitle'])}>{t('check_in.id_verification.heading')}</Text>
                            <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'verifyIdentityHeaderSubTitle'])}>{t('check_in.id_verification.sub_heading')}</Text>
                        </View>
                    </View>


                    <View style={getStyles(['widgetmainContainerChildContainer', 'verifyIdentityMainContainerChildContainer'])}>

                        <CustomDropDown
                            label={t('check_in.id_verification.select_id')}
                            placeholder={t('check_in.id_verification.select_id_placeholder')}
                            isRequired={true}
                            selectedOption={idVerificationLocalMediaFiles.selectedIdType?.key}
                            options={guestAllowedDocumentListData?.map(item => {
                                return {
                                    value: item.key,
                                    label: item.value
                                }
                                })}
                            onSelectOption={handleSelectedIDType}
                        />

                        <View style={getStyles(['verifyIdentityChildContainer_imageButtonContainer'])}>

                            <CustomPressable style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button', highlightNextStep == ID_FRONT && 'verifyIdentityChildContainer_imageButtonContainer_buttonSelected'])} onPress={() => handleOpenCamera(ID_FRONT)}>

                                <View style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button_iconContainer', highlightNextStep == ID_FRONT && 'verifyIdentityChildContainer_imageButtonContainer_button_iconContainerSelected'])}>
                                    <ImageComp source={idVerificationLocalMediaFiles.idImageUri ? RIGHT_CHECK : CROSS} style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button_icon', highlightNextStep == ID_FRONT && 'verifyIdentityChildContainer_imageButtonContainer_button_iconSelected'])} />
                                </View>

                                <View style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button_textContainer'])}>
                                    <Text style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button_textContainer_title', highlightNextStep == ID_FRONT && 'verifyIdentityChildContainer_imageButtonContainer_button_textContainer_titleSelected'])}>{t('check_in.id_verification.imageButton.id_image_front_heading')}</Text>
                                    <Text style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button_textContainer_subtitle', highlightNextStep == ID_FRONT && 'verifyIdentityChildContainer_imageButtonContainer_button_textContainer_subtitleSelected'])}>{t('check_in.id_verification.imageButton.id_image_front_subheading')}</Text>
                                </View>

                                <ImageComp source={CHEVRON_RIGHT} style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button_chevron', highlightNextStep == ID_FRONT && 'verifyIdentityChildContainer_imageButtonContainer_button_chevronSelected'])} />
                            </CustomPressable>


                            {
                                idVerificationLocalMediaFiles.selectedIdType.bothSideImageRequired &&

                                <CustomPressable style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button', highlightNextStep == ID_BACK && 'verifyIdentityChildContainer_imageButtonContainer_buttonSelected'])} onPress={() => handleOpenCamera(ID_BACK)}>

                                    <View style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button_iconContainer', highlightNextStep == ID_BACK && 'verifyIdentityChildContainer_imageButtonContainer_button_iconContainerSelected'])}>
                                        <ImageComp source={idVerificationLocalMediaFiles.idImageBackUri ? RIGHT_CHECK : CROSS} style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button_icon', highlightNextStep == ID_BACK && 'verifyIdentityChildContainer_imageButtonContainer_button_iconSelected'])} />
                                    </View>

                                    <View style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button_textContainer'])}>
                                        <Text style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button_textContainer_title', highlightNextStep == ID_BACK && 'verifyIdentityChildContainer_imageButtonContainer_button_textContainer_titleSelected'])}>{t('check_in.id_verification.imageButton.id_image_back_heading')}</Text>
                                        <Text style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button_textContainer_subtitle', highlightNextStep == ID_BACK && 'verifyIdentityChildContainer_imageButtonContainer_button_textContainer_subtitleSelected'])}>{t('check_in.id_verification.imageButton.id_image_back_subheading')}</Text>
                                    </View>

                                    <ImageComp source={CHEVRON_RIGHT} style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button_chevron', highlightNextStep == ID_BACK && 'verifyIdentityChildContainer_imageButtonContainer_button_chevronSelected'])} />
                                </CustomPressable>
                            }


                            {
                                !disableLivelinessCheck &&

                                <CustomPressable style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button', highlightNextStep == SELFIE && 'verifyIdentityChildContainer_imageButtonContainer_buttonSelected'])} onPress={() => handleOpenCamera(SELFIE)}>

                                    <View style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button_iconContainer', highlightNextStep == SELFIE && 'verifyIdentityChildContainer_imageButtonContainer_button_iconContainerSelected'])}>
                                        <ImageComp source={idVerificationLocalMediaFiles.selfieUri ? RIGHT_CHECK : CROSS} style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button_icon', highlightNextStep == SELFIE && 'verifyIdentityChildContainer_imageButtonContainer_button_iconSelected'])} />
                                    </View>

                                    <View style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button_textContainer'])}>
                                        <Text style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button_textContainer_title', highlightNextStep == SELFIE && 'verifyIdentityChildContainer_imageButtonContainer_button_textContainer_titleSelected'])}>{t('check_in.id_verification.imageButton.selfie_image_heading')}</Text>
                                        <Text style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button_textContainer_subtitle', highlightNextStep == SELFIE && 'verifyIdentityChildContainer_imageButtonContainer_button_textContainer_subtitleSelected'])}>{t('check_in.id_verification.imageButton.selfie_image_subheading')}</Text>
                                    </View>

                                    <ImageComp source={CHEVRON_RIGHT} style={getStyles(['verifyIdentityChildContainer_imageButtonContainer_button_chevron', highlightNextStep == SELFIE && 'verifyIdentityChildContainer_imageButtonContainer_button_chevronSelected'])} />
                                </CustomPressable>

                            }
                        </View>

                        <Text style={getStyles(['verifyIdentityChildContainer_infoText'])}>{t('check_in.id_verification.info_text')}</Text>

                        <View style={getStyles(['verifyIdentityChildContainer_buttonContainer'])}>

                            <CustomPressable style={getStyles(['primaryBtn'])}
                                disabled={(highlightNextStep != PROCEEDVERIFYID) || initializedVerifyIdentity}
                                onPress={() => setInitializedVerifyIdentity(true)}
                            >
                                {initializedVerifyIdentity ? (
                                    // <>
                                    //     <View style={{flexDirection: "row", gap: 8}}>
                                    //         <Loader size="small" style={getStyles(['primaryBtn_loader'])} />
                                    //         <Text style={getStyles(['primaryBtnTxt'])}>{t('check_in.id_verification.primary_button_active')}</Text>
                                    //     </View>
                                    // </>
                                    <Text style={getStyles(['primaryBtnTxt'])}>{t('check_in.id_verification.primary_button_active')}</Text>
                                ) : (
                                    <Text style={getStyles(['primaryBtnTxt'])}>{t('check_in.id_verification.primary_button')}</Text>
                                )}
                            </CustomPressable>

                            {(DEMO_FLOW_ENABLED || CHECKIN_DEMO_FLOW) &&
                                <CustomPressable style={getStyles(['secondaryBtn'])} onPress={handleSkip}>
                                    <Text style={getStyles(['secondaryBtnTxt'])}>{t('check_in.id_verification.skip')}</Text>
                                </CustomPressable>
                            }

                        </View>
                    </View>
                </ScrollView>

                {initializedVerifyIdentity &&
                    <ValidateConfidence
                        checkinSessionToken={checkinSessionToken}
                        lastName={lastName}
                        disableLivelinessCheck={disableLivelinessCheck}
                        selectedIdType={idVerificationLocalMediaFiles.selectedIdType}
                        idVerificationLocalMediaFiles={idVerificationLocalMediaFiles}

                        handleIdResponseError={() => handleSetIdVerificationLocalMediaFiles({ ...idVerificationLocalMediaFiles, idImageUri: "", idImageBackUri: "" })}
                        handleLivelinessError={() => handleSetIdVerificationLocalMediaFiles({ ...idVerificationLocalMediaFiles, selfieUri: "", selfieFiles: [] })}
                        handleClose={() => setInitializedVerifyIdentity(false)}
                        handleNext={handleConfidenceCheckNext}
                    />
                }
            </View>
        )
}

export default VerifyIdentity;
